import React from 'react';
import { Button } from '@mui/material';
import { ContainerSteps, PlanService, NetworkStatus, SelectedNetwork, InsurancePlan } from '../../utils/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { ButtonContainer, backButtonStyles } from './styles';
import { availableNetworks } from '../Networks';

type Props = {
    network: SelectedNetwork | undefined;
    service: PlanService | undefined;
    plan: InsurancePlan | undefined;
    step: ContainerSteps;
    setStep: (step:ContainerSteps) => void;
    clearService: () => void;
    clearMentalHealth: () => void;
    clearInsurancePlan: () => void;
    clearNetwork: () => void;
    clearMedicalGroup: () => void;
    clearProvider: () => void;
}

const BackButton = ({ network, service, plan, step, setStep, clearService, clearMentalHealth, clearInsurancePlan, clearNetwork, clearMedicalGroup, clearProvider }:Props): JSX.Element => {
    const handleClick = () => {
        switch (step) {
            case ContainerSteps.Service:
                clearInsurancePlan();
                clearService();
                setStep(ContainerSteps.Plan);
                return;
            case ContainerSteps.MentalHealth:
                clearMentalHealth();
                clearService();
                setStep(ContainerSteps.Plan);
                return;
            case ContainerSteps.Network:
                clearNetwork();
                clearService();
                if (service?.name === 'Mental Health') {
                    clearMentalHealth();
                    setStep(ContainerSteps.MentalHealth);
                    return;
                }
                setStep(ContainerSteps.Service);
                return;
            case ContainerSteps.MedicalGroup:
                clearMedicalGroup();
                clearNetwork();
                if (plan && availableNetworks(plan).length === 1) {
                    clearService();
                    clearMentalHealth();
                    setStep(ContainerSteps.Service);
                    return;
                }
                setStep(ContainerSteps.Network);
                return;
            case ContainerSteps.PCP:
                clearProvider();
                clearMedicalGroup();
                if (network?.status === NetworkStatus.SkipGroup) {
                    clearNetwork();
                    setStep(ContainerSteps.Network);
                    return;
                }
                setStep(ContainerSteps.MedicalGroup);
                return;
            default:
                clearService();
                clearInsurancePlan();
                clearNetwork();
                clearMentalHealth();
                clearProvider();
                clearMedicalGroup();
                setStep(ContainerSteps.Plan);
        }
    };
    return (
        <ButtonContainer sx={{ visibility: step !== ContainerSteps.Plan ? 'visible' : 'hidden' }}>
            <Button sx={backButtonStyles} variant="contained" onClick={handleClick}><FontAwesomeIcon icon={faArrowLeft} style={{ margin: '0px 2px 2px 0px' }}/> Back</Button>
        </ButtonContainer>
    );
};

export default BackButton;
